"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function noop(..._) { }
exports.default = noop;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm9vcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9ub29wLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsU0FBd0IsSUFBSSxDQUFDLEdBQUcsQ0FBUSxJQUFTLENBQUM7QUFBbEQsdUJBQWtEIn0=